import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Certified Assessments',
    title: 'Launch standardized, role-based tests in minutes',
    subtitle: 'Skip building from scratch. AI generates certified assessments tailored to specific roles, skill levels, and tech stacks — ready to send immediately.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #0076A3 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Role-Based Assessments',
      title: 'Assessments for every tech role',
      features: [
        { icon: '💻', title: 'Frontend Developer', desc: 'React, TypeScript, CSS, responsive design, component architecture, state management.' },
        { icon: '⚙️', title: 'Backend Engineer', desc: 'Python, Java, Node.js, API design, database optimization, system architecture.' },
        { icon: '☁️', title: 'DevOps / Cloud', desc: 'AWS, Docker, Kubernetes, CI/CD, infrastructure as code, monitoring.' },
        { icon: '📱', title: 'Mobile Developer', desc: 'React Native, Swift, Kotlin, app performance, offline-first patterns.' },
        { icon: '🧠', title: 'Data / ML Engineer', desc: 'Python, SQL, pandas, model training, feature engineering, data pipelines.' },
        { icon: '🔒', title: 'Security Engineer', desc: 'OWASP, encryption, authentication, network security, compliance.' },
      ],
      columns: 3,
    },
    {
      label: 'AI-Powered Generation',
      title: 'Upload a JD, get a complete assessment',
      desc: 'Paste or upload your job description. AI analyzes the requirements and generates a mix of multiple-choice, short-answer, and coding questions — with difficulty levels and scoring rubrics.',
      bullets: ['Auto-generated from job description', 'Mix of MCQ, short answer, and coding', 'Difficulty tags: Easy, Medium, Hard', 'Per-skill scoring breakdown', 'Customizable — add or remove questions'],
      visual: '🎯',
      visualLabel: 'AI Assessment Generator',
    },
  ],
  testimonial: { quote: 'We used to spend 2 hours building each assessment. Now AI generates better ones in 30 seconds. The skill coverage is incredible.', name: 'Alex T.', role: 'Engineering Manager, ScaleUp Inc.' },
  cta: { title: 'Generate your first assessment in seconds', desc: 'Upload a JD and let AI create a certified, role-specific assessment for you.' },
};

export default function CertifiedAssessmentsPage() { return <ProductPageTemplate data={DATA} />; }
